import { render, staticRenderFns } from "./DisplaySettings.vue?vue&type=template&id=5ecc914e&scoped=true"
import script from "./DisplaySettings.vue?vue&type=script&lang=js"
export * from "./DisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./DisplaySettings.vue?vue&type=style&index=0&id=5ecc914e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc914e",
  null
  
)

export default component.exports